export default function ($scope, $timeout, $mdDialog, $filter, Restangular, FlashService, purchases, invoices) {

    $scope.has_company = GetData().currentUser.company;
    $scope.purchases = [], $scope.invoices = [], $scope.payments = [], $scope.pending = [];

    $scope.pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    purchases.forEach(function (v, i) {

        let date = ParseDate(v.created);
        v.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(v.id, 4);

        if (v.status <= 99 && v.updated)
            $scope.purchases.push(v);
        else
            $scope.pending.push(v);
    });

    invoices.forEach(function (v, i) {

        if(!v.purchase) return;

        let date = ParseDate(v.created);
        v.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(v.purchase.id, 4);

        if(v.payment){
            $scope.payments.push(v);
        }else{
            $scope.invoices.push(v);
        }
    });

    $scope.removePending = function ($event, purchase, index) {

        let confirm = $mdDialog.confirm()
            .title($filter('translate')('CONFIRM_REMOVE_PURCHASE_PENDING'))
            .targetEvent($event)
            .ok($filter('translate')('REMOVE!'))
            .cancel($filter('translate')('CANCEL'));

        $mdDialog.show(confirm).then(function () {
            FlashService.Success("YOUR_PENDING_REMOVED");

            return Restangular
                .one("purchase", purchase.id)
                .remove()
                .then(data => {
                    $scope.pending.splice(index, 1);
                });


        });
    }

    $scope.viewInvoice = function ($event, invoice) {
        return Restangular
            .one("invoice", invoice.id)
            .one("pdf")
            .withHttpConfig({responseType: 'blob'})
            .get()
            .then(data => {
                data = data.data ? data.data : data;

                let fileName = 'BrainVt-'+invoice.numeration+'.pdf';
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                let file = new Blob([data], {type: 'application/pdf'});
                let fileURL = (window.URL || window.webkitURL).createObjectURL(file);

                //Open
                //window.open(fileURL);

                // Download
                a.href = fileURL;
                a.download = fileName;
                a.click();
                (window.URL || window.webkitURL).revokeObjectURL(data);

            });
    }

};


/** WEBPACK FOOTER **
 ** ./js/theme/invoices/controller.js
 **/